module.exports = __webpack_public_path__ + "img/front back rise 2.8639f311.jpeg";